'use client';

// Canal GLOBAL de avisos centrados del módulo (reemplaza a los toasts de esquina
// de sonner): cualquier vista/lib llama avisoExito/avisoError/avisoInfo y el
// <AvisoCentralHost/> (montado en el layout raíz) muestra la tarjeta centrada
// con el diseño institucional (backdrop + ícono que rebota + botón).

export type TipoAviso = 'exito' | 'error' | 'info';

export interface AvisoCentralData {
  tipo: TipoAviso;
  mensaje: string;
  detalle?: string;
}

type Oyente = (aviso: AvisoCentralData) => void;
let oyente: Oyente | null = null;

/** El host registra aquí su setState; devuelve la función para desregistrarse. */
export function registrarOyenteAvisos(fn: Oyente): () => void {
  oyente = fn;
  return () => { if (oyente === fn) oyente = null; };
}

function emitir(tipo: TipoAviso, mensaje: string, detalle?: string) {
  if (oyente) oyente({ tipo, mensaje, detalle });
  else console.warn(`[aviso ${tipo} sin host]`, mensaje, detalle ?? '');
}

/** Aviso verde de operación exitosa (título «Listo»). */
export const avisoExito = (mensaje: string, detalle?: string) => emitir('exito', mensaje, detalle);
/** Aviso rojo de error/validación (título «No se pudo completar», botón «Aceptar»). */
export const avisoError = (mensaje: string, detalle?: string) => emitir('error', mensaje, detalle);
/** Aviso neutro informativo (título «Atención»). */
export const avisoInfo = (mensaje: string, detalle?: string) => emitir('info', mensaje, detalle);
